import { InstructionRow } from '@components/Common/InstructionRow';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AnimateIntoView, NoddiCard, NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';

export const RequestSentScreen = () => (
  <ContentWrapperCustomerApp hideBackButton>
    <AnimateIntoView direction='fromBottom'>
      <p className='mt-20 text-4xl font-bold text-primary'>
        {/* eslint-disable-next-line noddi/no-emoji-in-ui -- product asked for a celebration on this thank-you title; outside the message so its translations still apply */}
        <Trans>Thank you for your request!</Trans> 🎉
      </p>
      <p className='mt-7 text-3xl font-bold text-noddiPurple'>
        <Trans>What happens next?</Trans>
      </p>

      <NoddiCard className='mt-4' contentClassName='flex flex-col gap-3'>
        <InstructionRow
          icon='ClipboardList'
          title={t`We review your request`}
          description={t`We go through the details you sent us.`}
        />
        <InstructionRow
          icon='Wheel'
          title={t`Tire offers made for you`}
          description={t`Our team creates tire offers tailored to your needs.`}
        />
        <InstructionRow
          icon='MessageSquare'
          title={t`Offers by SMS`}
          description={t`You get an SMS with your tire offers as soon as they are ready.`}
        />
      </NoddiCard>

      <div className='mt-4 flex justify-end'>
        <NoddiLink to={customerRoutes.homepage.getPath()}>
          <Trans>Close</Trans>
        </NoddiLink>
      </div>
    </AnimateIntoView>
  </ContentWrapperCustomerApp>
);
